import {
	Select,
	Text,
	Upload,
	FormGroupInterface,
	FORM_TYPE,
	VALIDATION_TYPE,
	TimeDuration,
} from '../../types';

interface ILinkAssesorOptions {
	assessorId?: string;
	nameOfAssessor?: string;
	nameOfTrainee?: string;
	assessmentAgencyOptions?: any[];
	jobRoles?: any[];
	selectedJobRoles?: any[];
	submitText?: string;
	cancelText?: string;
	supportingDocuments?: string;
	validity?: any;
}

export function getLinkNewAssesorForm(
	data: ILinkAssesorOptions = {},
	on: any = {},
	hide: any = {},
	disabled: any = {},
) {
	const linkNewAsssessorForm: FormGroupInterface = {
		label: '',
		type: FORM_TYPE.MODAL,
		submitText: data.submitText,
		// submitText: 'Generate OTP',
		cancelText: data.cancelText,
		// cancelText: 'Cancel',
		row: false,
		forms: [
			{
				formElements: [
					new Text('Enter Assessor SIP ID:', {
						name: 'assessorId',
						// silentRequired: true,
						required: true,
						row: false,
						// hide: hide.assessorId,
						disabled: disabled.assessorId || disabled.all,
						placeholder: 'Enter Assessor ID',
						onBlur: on.blurAssessorId,
						onChange: on.assessorIdChange,
						value: data.assessorId,
					}),
					new Text('Name of the Assessor:', {
						value: data.nameOfAssessor || '',
						name: 'nameOfAssessor',
						hide: hide.nameOfAssessor,
						placeholder: 'Name of the Assessor Pre-filled',
						row: false,
						disabled: true,
						required: true,
						silentRequired: true
					}),
					new Select(
						'Assessment Agency Aligned:',
						data.assessmentAgencyOptions || [],
						{
							row: false,
							name: 'assessmentAgencyAligned',
							value: data.nameOfTrainee,
							disabled: disabled.nameOfTrainee || disabled.all,
							required: true,
							asyncLoad: true,
							// silentRequired: true
						}
					),
					new TimeDuration(
						'Validity',
						[
							{
								placeholder: 'Select From Date:',
								name: 'fromDate'
							},
							{
								placeholder: 'Select To Date:',
								name: 'toDate'
							},
						],
						{
							required: true,
							name: 'validity',
							value: data.validity,
							validationType: VALIDATION_TYPE.DATE_DURATION,
							disabled: disabled.validity || disabled.all,
							toDateRequired: false,
						}
					),
					new Upload(
						'Upload Supporting Documents:', {
							required: true,
							name: 'supportingDocuments',
							value: data.supportingDocuments,
							disabled: disabled.supportingDocuments || disabled.all,
							placeholder: 'Choose Supporting Documents'
						}
					),
					// new Select(
					// 	'Associated Job Roles:',
					// 	data.jobRoles,
					// 	{
					// 		required: true,
					// 		value: data.selectedJobRoles,
					// 		multi: true
					// 	}
					// )
				]
			}
		]
	};
	return linkNewAsssessorForm;
}
